module.exports = __webpack_public_path__ + "img/s1-team6.8444dc36.png";